import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { BiometricsDataService } from 'src/app/services/biometrics/biometrics-data.service';
import { BiometricsService } from 'src/app/services/biometrics/biometrics.service';
import { CameraCheckerService } from 'src/app/services/biometrics/camera-checker.service';
import { GetPresignedUrlService } from 'src/app/services/biometrics/get-presigned-url.service';
import { GetSdkParamsService } from 'src/app/services/biometrics/get-sdk-params.service';
import {
  COMPONENT_MANAGER_ADO,
  LOADER_STYLES_ADO,
  MAIN_STYLES_ADO,
  MAX_WIDTH_MOBILE,
  SCRIPT_ADO
} from 'src/app/shared/data/biometrics.constants';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { AnalyticService } from 'src/app/shared/services/analytic.service';

@Component({
  selector: 'app-biometrics-init',
  template: ''
})
export class BiometricsInitComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  constructor(
    private getSdkParamsService: GetSdkParamsService,
    private router: Router,
    private analyticsService: AnalyticService,
    private cameraCheckerService: CameraCheckerService,
    private biometricsService: BiometricsService,
    private biometricsDataService: BiometricsDataService,
    private getUrlService: GetPresignedUrlService
  ) {}

  ngOnInit() {
    this.verifyDevice();
  }

  verifyDevice(): void {
    this.setBackgroundColor();
    this.subscriptions.add(
      this.cameraCheckerService.checkCamera().subscribe(
        (r: boolean) => {
          if (r === true) {
            this.initializeBiometrics();
            return;
          }
          this.analyticsService.uTagLinkError(
            'Error el usuario no tiene camara web',
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.CAMERA.redirectPath]);
        },
        (e) => {
          const errorMessage = e.message ?? '';
          this.analyticsService.uTagLinkError(
            'Error servicio intentando acceder a la camara del usuario ' +
              errorMessage,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
        }
      )
    );
  }

  initializeBiometrics = () => {
    this.loadBiometricScripts();
    this.checkMobile();
    this.getBiometricsConfiguration();
  };

  loadBiometricScripts(): void {
    this.biometricsService.loadCSS(MAIN_STYLES_ADO);
    this.biometricsService.loadCSS(LOADER_STYLES_ADO);
    this.biometricsService.loadScript(COMPONENT_MANAGER_ADO);
    this.biometricsService.loadScript(SCRIPT_ADO);
  }

  getBiometricsConfiguration() {
    this.subscriptions.add(
      forkJoin([
        this.getSdkParamsService.getParams(),
        this.getUrlService.getPresignedUrl()
      ]).subscribe(
        ([sdkParams, presignedUrls]) => {
          if (sdkParams.status === 200 && presignedUrls.status === 201) {
            this.setConfiguration(sdkParams, presignedUrls);
            this.router.navigate([
              routesData.BIOMETRY.INFO.redirectPath,
              'rostro'
            ]);
            return;
          }
          this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
        },
        (error) => {
          const errorMessage = error.message ?? '';
          this.analyticsService.uTagLinkError(
            'Error en los servicios de configuracion de biometria ' +
              errorMessage,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
        }
      )
    );
  }

  setConfiguration(
    sdkParams: HttpResponse<any>,
    presignedUrls: HttpResponse<any>
  ) {
    this.biometricsService.sdkParams = sdkParams.body;
    this.biometricsDataService.presignedUrls.rostro =
      presignedUrls.body.UploadLiveness;
    this.biometricsDataService.presignedUrls['documento-frontal'] =
      presignedUrls.body.UploadDocumentFrontSide;
    this.biometricsDataService.presignedUrls['documento-posterior'] =
      presignedUrls.body.UploadDocumentBackSide;
  }

  checkMobile(): void {
    if (window.innerWidth <= MAX_WIDTH_MOBILE) {
      this.biometricsDataService.routingBiometrics =
        this.biometricsDataService.routingBiometricsMobile;
      this.biometricsService.isMobile = true;
    }
  }

  setBackgroundColor(): void {
    this.biometricsService.setBG();
    this.biometricsService.checkRoutesBG();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
